import { Injectable } from '@angular/core';


@Injectable()
export class projectRepository {

  async projectData() {
    const resp = await fetch('https://whatsdare.com/api/v4/projects/419/labels?private_token=XWg2dcYKzTKpqBDeGzdA');
    const data = await resp.json();
    return data;
  }
  
}